import { getRefElement } from './getRefElement';
/**
 * remove className from element, default will not scan child nodes, if you want to scan child nodes, set `scanChildren` to `true`.
 *
 * @param target target element reference or element or callback
 * @param removeClass className to remove, default will use class `includes` to check, if you want to use full match, set `fullMatch` to `true`
 *
 * @example
 * ```js
 * elm => <div class="abc bcd efg abc-def"></div>
 *
 * removeClassName(elmRef, 'bcd');
 *
 * elm => <div class="abc efg abc-def"></div>
 *
 * removeClassName(elmRef, 'abc');
 * elm => <div class="efg"></div>
 * ```
 */
export function removeClassName(target, removeClass, _a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.scanChildren, scanChildren = _c === void 0 ? false : _c, _d = _b.fullMatch, fullMatch = _d === void 0 ? false : _d;
    var elm = getRefElement(target);
    if (!elm)
        return;
    if (elm.className.includes(removeClass)) {
        elm.className = cleanClass(elm, removeClass, fullMatch);
    }
    if (scanChildren) {
        var nodes = elm.querySelectorAll("[class*=\"" + removeClass + "\"]");
        if ((nodes === null || nodes === void 0 ? void 0 : nodes.length) > 0) {
            nodes.forEach(function (node) { return (node.className = cleanClass(node, removeClass, fullMatch)); });
        }
    }
}
function cleanClass(elm, removeClass, fullMatch) {
    return elm.className
        .trim()
        .split(/\s+/)
        .filter(function (className) {
        return !(fullMatch
            ? className === removeClass
            : className.includes(removeClass));
    })
        .join(' ');
}
